import produce from 'immer';
export var getInitialState = function () { return ({
    appsLoading: false,
    appsError: false,
    apps: [],
    selectedItemKey: '',
    searchString: '',
}); };
function globalSearchReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_APPS_REQUEST':
                state.appsLoading = true;
                state.appsError = false;
                break;
            case 'LOAD_APPS_SUCCESS':
                state.appsLoading = false;
                state.appsError = false;
                state.apps = action.apps || [];
                break;
            case 'LOAD_APPS_FAILURE':
                state.appsLoading = false;
                state.appsError = true;
                state.apps = [];
                break;
            case 'UPDATE_SEARCH_STRING_SUCCESS':
                state.searchString = action.searchString;
                break;
            case 'UPDATE_SELECTED_ITEM_SUCCESS':
                state.selectedItemKey = action.selectedItemKey;
                break;
            default:
                break;
        }
    });
}
export default globalSearchReducer;
